import * as React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Pagination } from '@mui/material'

export default function MUITable({ data, page, perPage, setPage, setPerPage }: any) {
  const handleChangePage = (event: unknown, newPage: number) => {
    console.log('Page change:', newPage);
    setPage(newPage);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newPerPage = parseInt(event.target.value, 10);
    console.log('Rows per page change in MUITable:', newPerPage);
    setPerPage(newPerPage);
    setPage(1);
  }

  React.useEffect(() => {
    if (data?.pagination?.lastPage === 1) {
      setPage(1);
    }
  }, [data?.pagination, setPage]);

  const rows = React.useMemo(() => {
    return data?.table?.rows || [];
  }, [data]);

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer>
        <Table aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {data?.table?.columns?.map((column: any) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, fontWeight: 'bold', fontSize: '12px' }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row: any, index: number) => (
              <TableRow hover role='checkbox' tabIndex={-1} key={index}>
                {data?.table?.columns?.map((column: any) => {
                  const value = row[column.id];
                  return (
                    <TableCell key={column.id} align={column.align}>
                      {value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className='d-flex justify-content-between align-items-center p-3'>
        <div className='d-flex align-items-center gap-2'>
          <label className='mb-0'>Rows per page:</label>
          <select
            className='form-select form-select-sm'
            value={perPage}
            onChange={handleChangeRowsPerPage}
            style={{ width: '80px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
          </select>
      
        </div>

        <Pagination
          count={data?.pagination?.lastPage || 0}
          page={page}
          onChange={handleChangePage}
          shape='rounded'
          size='small'
          color='primary'
        />
      </div>
    </Paper>
  )
}
